import { render } from "./SectionPortfolioDetailImage.vue?vue&type=template&id=674db597&scoped=true"
import script from "./SectionPortfolioDetailImage.vue?vue&type=script&lang=js"
export * from "./SectionPortfolioDetailImage.vue?vue&type=script&lang=js"

import "./SectionPortfolioDetailImage.vue?vue&type=style&index=0&id=674db597&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674db597"]])

export default __exports__